module.exports = " <div class=star :class=starType> <span v-for=\"itemClass in itemClasses\" :class=itemClass class=star-item track-by=$index></span> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/star/star.vue
// module id = 83
// module chunks = 1